import React from 'react';
import ReportsList from './ReportsList';

const AlarmReportsAll = () => {
  return (
    <ReportsList
      endpoint="listPdfFolder/?folder=alarm-reports"
      title="All Sites Alarm Reports"
      allColumns={false}
      enableFilters={true}
      filenamePrefix="alarm-reports"
      filenameFilter="-All-"
    />
  );
};

export default AlarmReportsAll;
